import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import Clock from '@blade/common/components/clock/index.vue';
import ScreenHead, { MAP_ITEMS } from '@blade-sxp/screen/components/back-screen-head/screen-head.vue';
import { SENSECODE } from '@blade/common/constants/code';
import SnapShot from '@blade/common/components/screen-head/snapshot.vue';
import moment from 'moment';
import store from '@blade-sxp/screen/store/index';
import { fetchWeather } from '@blade-sxp/screen/api/index';
import { LoginModule } from '@blade/common/store/login';
let default_1 = class extends Vue {
    celsius = 0; // 摄氏度
    weather = ''; // 温度
    defaultLogoUrl = ''; // 默认图片url
    defaultLogoName = ''; // 默认名称
    get snapTime() {
        return store.snapTime;
    }
    get freezeTime() {
        return this.snapTime?.split(' ')[1];
    }
    get freezeDay() {
        return this.snapTime?.split(' ')[0];
    }
    get isButtonDisAble() {
        return store.isButtonDisAble;
    }
    get backRootMainAngle() {
        return store.backRootMainAngle;
    }
    get ueMap() {
        return store.ueMap;
    }
    get path() {
        return this.$route.path;
    }
    get isBuildInformation() {
        return this.path === '/screen/buildInformation';
    }
    get isCrowdInsightBackEndVa() {
        const [crowdInsightBackEndVa] = MAP_ITEMS.filter((item) => {
            return item.code === SENSECODE.CROWD_VA;
        });
        console.log('===crowdInsightBackEndVa', crowdInsightBackEndVa);
        return this.$route.path === crowdInsightBackEndVa.path;
    }
    mounted() {
        this.setWeather();
        this.setHeadLogo();
    }
    setHeadLogo() {
        try {
            this.defaultLogoUrl = LoginModule?.logoConfig?.defaultLogoUrl;
            this.defaultLogoName = LoginModule?.logoConfig?.systemName;
        }
        catch (e) { }
    }
    async setWeather() {
        const dateTime = moment().format('YYYY-MM-DD HH:mm:ss');
        const { weatherText, celsius } = (await fetchWeather({ dateTime }));
        this.celsius = celsius;
        this.weather = weatherText;
    }
    snapDateChange(time) {
        console.log('====', time);
        store.updateSnapTime(time);
    }
    // 更新视角
    updateMainAngle(mainAngle) {
        store.updateCurrentBuildId('');
        store.updateZoneId(store.rootId);
        store.updateIsButtonDisAble(false);
        store.updateBackMainAngle(mainAngle);
        this.ueMap.zoomReset();
        this.ueMap.resetSection();
    }
    // 返回主区域
    returnHome() {
        this.updateMainAngle(this.backRootMainAngle);
    }
    // 返回上层区域
    backUp() {
        this.updateMainAngle(this.backRootMainAngle);
    }
};
default_1 = __decorate([
    Component({
        name: 'buildtop',
        components: { Clock, ScreenHead, SnapShot },
    })
], default_1);
export default default_1;
